export default "__VITE_ASSET__DkBRHy6X__"